const hiMessages = {
  /* 01.General */
 "main.name": "नाम",
  "main.sentiment": "भावना",
  "main.urgency": "तात्कालिकता",
  "main.language": "भाषा",
  "main.agent": "एजेंट",
  "main.property_name": "संपत्ति का नाम",
  "main.booking_number": "बुकिंग नंबर",
  "main.check_out": "चेक आउट",
  "main.check_in": "चेक इन",
  "main.adults": "वयस्क",
  "main.corporate_code": "कॉर्पोरेट कोड",
  "main.group_code": "समूह कोड",
  "main.promo_code": "प्रोमो कोड",
  "main.ai_response": "AI प्रतिक्रिया",
  "main.template_response": "टेम्पलेट प्रतिक्रिया",
  "main.converttoticket": "टिकट में बदलें",
  "main.switch_property": "संपत्ति बदलें",
  "main.Group_id": "समूह ID",
  "main.integration_id": "एकीकरण ID",
  "main.submit": "जमा करें",
  "main.cancel": "रद्द करें",
    "main.select_template": "टेम्पलेट चुनें",
  "main.rooms": "कमरे",
  "main.rates": "दरें",

  //footer
    "footer.knowledge": "ज्ञान",
  "footer.home": "होम",
  "footer.help": "सहायता",

  //ticket
  "ticket.thank_you": "फ़ॉर्म सबमिट करने के लिए धन्यवाद",
  "ticket.ticket": "टिकट",
  "ticket.details": "कृपया टिकट विवरण का वर्णन करते हुए फ़ॉर्म भरें।",
  "ticket.select_category": "श्रेणी चुनें",
  "ticket.category": "श्रेणी",
  "ticket.title": "शीर्षक",
  "ticket.notes": "टिप्पणियाँ",
  "ticket.status": "स्थिति",
  "ticket.assigned_to": "को सौंपा गया",
  "ticket.submit_form": "फ़ॉर्म सबमिट करें",

  
  "main.total": "कुल",
  "main.pastetooutlook": "Outlook में पेस्ट करें",
  "main.children": "बच्चे",
  "main.promocode": "प्रोमो/कॉर्पोरेट/ग्रुप कोड",
  "main.exact_match_only": "केवल सटीक मिलान",
  "main.search": "खोजें",
  "main.no_rate_match": "आपके चयन से मेल खाने वाली कोई दर उपलब्ध नहीं है। कृपया अपनी खोज बदलें और पुनः प्रयास करें।",
  "main.translate_to": "अनुवाद करें",
  "main.regenerate": "पुनः उत्पन्न करें",
  "main.copy_text": "टेक्स्ट कॉपी करें",
  "main.additional_instructions": "अतिरिक्त निर्देश",

  "faq.helpcenter": "सहायता केंद्र",
  "faq.reply.email.sabre.question": "Aven Hospitality Concierge Email Automation का उपयोग करके ईमेल का उत्तर कैसे दें?",
  "faq.reply.email.sabre.answer": "ईमेल खोलें और Aven Hospitality ऐड-इन लॉन्च करें। आप तीन विकल्पों में से चुन सकते हैं: पूर्व-निर्धारित टेम्पलेट का उपयोग करें, AI प्रतिक्रिया उत्पन्न करें, या ईमेल को टिकट में बदलें। उपयुक्त विकल्प चुनें, प्रतिक्रिया की समीक्षा करें, आवश्यक बदलाव करें और Outlook से सीधे भेजें।",

  "faq.rates.availability.question": "मैं अपने उत्तर में दरें, उपलब्धता और कमरे की जानकारी कैसे जोड़ूं?",
  "faq.rates.availability.answer": "+ Rates सुविधा का उपयोग करके तारीख और मेहमानों की संख्या जैसी जानकारी दर्ज करें। Concierge आपके उत्तर में सही उपलब्धता और कीमत जोड़ देगा। आप + Rooms का उपयोग करके कमरे का विवरण और चित्र भी जोड़ सकते हैं।",

  "faq.different.language.question": "यदि ईमेल किसी अन्य भाषा में है तो मुझे क्या करना चाहिए?",
  "faq.different.language.answer": "Aven Hospitality Concierge आपको आने वाले ईमेल को आपकी पसंदीदा भाषा में अनुवाद करने की सुविधा देता है।",

  "faq.pin.addin.question": "मैं कैसे सुनिश्चित करूं कि ऐड-इन Outlook में हमेशा उपलब्ध रहे?",
  "faq.pin.addin.answer": "Aven Hospitality Concierge ऐड-इन को Outlook में पिन करें ताकि यह हमेशा दिखाई दे।",

  "faq.knowledge.hub.question": "Knowledge Hub खोज विकल्प क्या है?",
  "faq.knowledge.hub.answer": "Knowledge Hub खोज आपको Outlook के अंदर संपत्ति से संबंधित जानकारी जल्दी खोजने में मदद करती है।",

  "faq.reply.email.myma.question": "Myma का उपयोग करके ईमेल का उत्तर कैसे दें?",
  "faq.reply.email.myma.answer": "ईमेल खोलें और Myma ऐड-इन लॉन्च करें। आप टेम्पलेट का उपयोग कर सकते हैं, AI उत्तर बना सकते हैं या ईमेल को टिकट में बदल सकते हैं।",

  "faq.room.details.question": "मैं अपने उत्तर में कमरे का विवरण कैसे जोड़ूं?",
  "faq.room.details.answer": "+ Rooms का उपयोग करके कमरे का विवरण और चित्र जोड़ें।",

  "faq.myma.different.language.question": "यदि ईमेल किसी अन्य भाषा में है तो मुझे क्या करना चाहिए?",
  "faq.myma.different.language.answer": "Myma आपको आने वाले ईमेल को आपकी पसंदीदा भाषा में अनुवाद करने की अनुमति देता है।",

  "faq.myma.pin.addin.question": "मैं कैसे सुनिश्चित करूं कि ऐड-इन Outlook में हमेशा उपलब्ध रहे?",
  "faq.myma.pin.addin.answer": "Myma ऐड-इन को Outlook में पिन करें ताकि यह प्रत्येक ईमेल के साथ स्वचालित रूप से खुले।",

};
export default hiMessages;